import "devextreme/dist/css/dx.common.css";

export function getAvailableThemes() {
  return availableThemes;
}

export function applyCurrentTheme() {
  window.location.reload();
}

export function loadTheme(userTheme) {
  console.log("Trying to load theme", userTheme);
  switch (userTheme) {
    case "generic.dark":
      import('devextreme/dist/css/dx.dark.css');
      break;
    case "generic.light":
      import('devextreme/dist/css/dx.light.css');
      break;
    case "generic.softblue":
      import('devextreme/dist/css/dx.softblue.css');
      break;
    case "generic.carmine":
      import('devextreme/dist/css/dx.carmine.css');
      break;
    case "generic.greenmist":
      import('devextreme/dist/css/dx.greenmist.css');
      break;
    case "material.blue.light":
      import('devextreme/dist/css/dx.material.blue.light.css');
      break;
    case "material.blue.dark":
      import('devextreme/dist/css/dx.material.blue.dark.css');
      break;
    default:
      console.log("Using default theme", defaultTheme);
      import("devextreme/dist/css/dx.light.css")
      break;
  }
}

const defaultTheme = "generic.light";

const availableThemes = [
  {
    id: "generic.light",
    text: "Generic Light",
  },
  {
    id: "generic.dark",
    text: "Generic Dark",      
  },
  {
    id: "generic.softblue",
    text: "Generic Soft Blue",      
  },
  {
    id: "generic.carmine",
    text: "Generic Carmine",      
  },
  {
    id: "generic.greenmist",
    text: "Generic Green Mist",      
  },
  {
    id: "material.blue.light",
    text: "Material Light (Experimental)",
  },
  {
    id: "material.blue.dark",
    text: "Material Dark (Experimental)",
  },
];


